import { Topup } from "@widgets/wallet";
import { FC } from "react";

export const TopupPage: FC = () => {
  return <Topup />;
};
